import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	mappingModalDropdownMenuTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-picker.mapping-modal-dropdown-menu-title',
		defaultMessage: 'Select priority',
		description: 'Dropdown menu title for selecting a priority when mapping',
	},
	mappingModalDropdownChevronDownIconLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-picker.mapping-modal-dropdown-chevron-down-icon-label',
		defaultMessage: 'priority scheme mapping chevron down',
		description: 'Dropdown menu label for dropdown chevron icon',
	},
});

export default messages;
